import React from 'react';
import PropTypes from 'prop-types';

const TabIcon = ({ icon, label, desc }) => (
  <div className="items-center w-[158px] h-[140px] justify-between p-2.5 flex flex-col">
    <div />
    {icon}
    <div className="flex flex-col leading-[15px] min-h-[30px]">
      <span className="text-[12px]">{label}</span>
      <span className="text-[12px] text-gray-light2">{desc}</span>
    </div>
  </div>
);

TabIcon.propTypes = {
  desc: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

export default TabIcon;
